<!--
 * @Author: cmchiu
 * @Date: 2022-09-06 17:47:30
 * @LastEditTime: 2023-02-03 17:56:18
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \LearningMarket2\LearningMarket-ClientApp\src\views\CourseBook.vue
 * 
-->
<template>
    <div class="course-book">
        <div
            class="row mt-3"
            v-loading.fullscreen.lock="configs.loading"
            element-loading-text="加載中，請稍候..."
            element-loading-background="rgba(255, 255, 255, 0.5)"
        >
            <div class="col-lg-12 class_content01">
                <div class="text-right" v-if="!act && act !== 'view'">
                    <span class="content_ntmtext">尚有</span>
                    <span class="content_num">{{ courseData.balance }}</span>
                    <span class="content_ntmtext">個名額</span>
                </div>
                <p
                    class="card-title"
                    v-show="!!courseData.LMAT_Class"
                    :class="
                        courseData.LMAT_Class === '1001'
                            ? 'card_language' // 語文學習
                            : courseData.LMAT_Class === '1002'
                            ? 'card_tech' // 資訊科技
                            : courseData.LMAT_Class === '1003'
                            ? 'card_method' // 學習方法
                            : courseData.LMAT_Class === '1004'
                            ? 'card_basic' // 基礎科目輔導課
                            : courseData.LMAT_Class === '1005'
                            ? 'card_heart' // 心靈成長
                            : courseData.LMAT_Class === '1006'
                            ? 'card_paper' // 論文達人
                            : courseData.LMAT_Class === '1007'
                            ? 'card_career' // 職涯活動
                            : courseData.LMAT_Class === '1010'
                            ? 'card_workshop' // 校園活動(講座)
                            : courseData.LMAT_Class === '1011'
                            ? 'card_student' // 學生講師
                            : courseData.LMAT_Class === '1012'
                            ? 'card_meeting' // 教師請益時間
                            : ''
                    "
                >
                    {{ courseData.LMAT_ClassName }}
                </p>
                <p class="card-text card_class">{{ courseData.LMIT_Name_1000 }}</p>
                <p class="card-text card_class" v-show="!!courseData.LMIT_Name_2000">{{ courseData.LMIT_Name_2000 }}</p>
                <div class="class_content_text">
                    <span v-if="courseData.LMIT_STime">
                        開課日期： {{ courseData.LMIT_STime.substr(0, 10) }}
                        <br />
                    </span>
                    <span v-if="courseData.LMIT_STime && courseData.LMIT_ETime">
                        開課時段： {{ courseData.LMIT_STime.substr(10) }} ~ {{ courseData.LMIT_ETime.substr(10) }}
                        <br />
                    </span>
                    <span>
                        期別地點： {{ courseData.LMIT_Place }}
                        <br />
                    </span>
                    <span>
                        主講人： {{ courseData.LMIT_Lecturer }}
                        <br />
                    </span>
                    <span>
                        主講人Email： {{ courseData.LMIT_LecturerEmail }}
                        <br />
                    </span>
                    <span v-show="!!courseData.LMIT_Emcee">
                        活動主持人： {{ courseData.LMIT_Emcee }}
                        <br />
                    </span>
                    <span v-show="!!courseData.LMIT_Contact">
                        活動聯絡人： {{ courseData.LMIT_Contact }}
                        <br />
                    </span>
                    <span v-show="!!courseData.LMIT_ContactEmail">
                        聯絡人Email： {{ courseData.LMIT_ContactEmail }}
                        <br />
                    </span>
                    課程說明：<br />
                    <div v-html="courseData.LMIT_Description_1000"></div>
                    <div v-html="courseData.LMIT_Description_2000" v-show="!!courseData.LMIT_Description_2000"></div>
                    <span v-if="courseData.roles">
                        身分限制： {{ courseData.roles.join('、') }}
                        <div
                            v-if="courseData.roles.includes('在校生') && courseData.rolesDetail.length > 0"
                            style="margin-left: 20px; font-size: 11pt"
                        >
                            <b>在校生</b>不包含&nbsp;<span style="color: red">
                                {{ courseData.rolesDetail.join('、') }}
                            </span>
                        </div>
                        <br v-else />
                    </span>
                    <span v-show="!!courseData.LMIT_Rule">
                        課程要求：
                        <div v-html="courseData.LMIT_Rule" style="margin-left: 20px"></div>
                    </span>
                    <span> 可預約時間： {{ courseData.LMIT_BSTime }} ~ {{ courseData.LMIT_BETime }} </span>
                </div>

                <div class="text-center mt-3" v-if="!act && act !== 'view'">
                    <span
                        v-if="!user.isLogin"
                        v-show="chkCourse"
                        style="color: red; border: 1px solid red; padding: 0.3rem 0.5rem"
                    >
                        若要預約，請先登入系統。
                    </span>
                    <div v-else-if="!chkRole">
                        <div v-if="!!user.absent">
                            <p style="color: red">很抱歉! 您在三個月內有三次以上缺席紀錄，將停止課程預約權利三個月。</p>
                            <div id="absent-log">
                                <h6>最近的缺席紀錄如下：</h6>
                                <ul>
                                    <li v-for="log in user.absent.Logs" :key="log.index">{{ log }}</li>
                                </ul>
                            </div>
                            <div class="row">
                                <div class="col-2" style="color: darkorange">暫停預約起訖時間：</div>
                                <div class="col-10" style="font-weight: bold; color: darkorange">
                                    {{ user.absent.LockPeriod }}
                                </div>
                                <div class="col-2" style="color: green">最快可以預約時間：</div>
                                <div class="col-10" style="font-weight: bold; color: green">
                                    {{ user.absent.ReviveDate }}
                                </div>
                            </div>
                        </div>
                        <p v-show="chkCourse" style="color: red" v-html="bookingMsg"></p>
                    </div>
                    <div v-else>
                        <el-divider content-position="left"></el-divider>
                        <el-form
                            ref="form"
                            :model="user"
                            :rules="userRules"
                            label-width="auto"
                            hide-required-asterisk
                            class="class_content_text"
                        >
                            <el-form-item label="Email：" prop="email" required>
                                <el-input v-model="user.email" :maxlength="50"></el-input>
                            </el-form-item>
                            <el-form-item label="聯絡電話：" prop="phone" required>
                                <el-input
                                    v-model.trim="user.phone"
                                    :maxlength="20"
                                    placeholder="例: 0912-345678 或 02-27005858"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div>
                        <el-button class="go-back" @click="go2CourseLs" v-show="false">回上一頁</el-button>
                        <el-button
                            class="submit-booking"
                            v-if="chkCourse && chkRole && user.isLogin"
                            @click="submitRegister"
                        >
                            我要預約
                        </el-button>
                    </div>
                </div>
            </div>

            <div class="col-lg-12 class_content02" v-if="!act && act !== 'view'">
                <div class="row">
                    <div class="col-lg-4 col-sm-4 col-12 text-center">
                        <img src="assets/images/learningmarket/notice.png" alt="" />
                    </div>
                    <div class="col-lg-8 col-sm-8 col-12">
                        <h5>課程預約注意事項：</h5>

                        <p>1. 課程預約所有資料將列為個人學習歷程記錄，請確實填寫。</p>

                        <p>2. 若無法前來上課，請於開課前一天取消您的預約（當日將不開放取消）。</p>

                        <p>3. 各課程授課教師會記錄預約者出缺席狀況，敬請按時上課。</p>

                        <p>
                            4. 預約後，三個月內無故不到(無取消預約)達三次以上者(含第三次)者，將停止課程預約權利三個月。
                        </p>

                        <!-- <p>5. 三個月內<span style="color: Red">取消預約</span>次數達三次者，視同一次無故不到。</p> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-12 class_content02" v-if="act && act === 'view' && user.isLogin && canComment">
                <div class="row">
                    <div class="col-lg-4 col-sm-4 col-12 text-center">
                        <img src="assets/images/learningmarket/notice.png" alt="" />
                    </div>
                    <div class="col-lg-8 col-sm-8 col-12">
                        <h5>評價與回饋</h5>

                        <ul>
                            <li>
                                評價:
                                <el-rate v-model="score" :disabled="submitted"></el-rate>
                            </li>
                            <li>
                                回饋訊息:
                                <el-input
                                    v-model="feedback"
                                    placeholder="請輸入回饋訊息..."
                                    type="textarea"
                                    resize="none"
                                    :autosize="{ minRows: 2, maxRows: 4 }"
                                    :disabled="submitted"
                                ></el-input>
                            </li>
                            <li style="text-align: center" v-if="!submitted">
                                <el-button class="submit-feedback" @click="submitFeeback">送出意見</el-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import { getCourseInfo, getFeedbackList, updateBookingFeedback, checkBooking, bookCourse } from '@/api/course'
import { checkPhone, checkEmail } from '@/utils/common'

export default {
    name: 'CourseBook',

    data: function () {
        return {
            configs: {
                loading: false,
            },
            user: {
                isLogin: false,
                id: '',
                name: '',
                class: '',
                email: '',
                phone: '',
                sdrgValue: '',
                sdrgText: '',
                statusText: '',
                absent: null,
            },
            userRules: {
                email: [{ validator: checkEmail, trigger: 'blur' }],
                phone: [{ validator: checkPhone, trigger: 'blur' }],
            },
            LMIT_ID: this.$route.query.id,
            courseData: {},
            score: 3,
            feedback: '',
            act: null,
            canComment: false,
            submitted: false,
            chkCourse: false,
            chkRole: false,
            bookingMsg: '',
        }
    },

    created: function () {
        this.act = this.$route.query.act
        this.getCourseInfo()
    },

    mounted: function () {},

    watch: {
        '$store.getters.isLogin': function (newVal, oldVal) {
            if (newVal != oldVal && newVal) {
                this.getCourseInfo()
            }
            this.user.isLogin = newVal
        },
        '$store.getters.reload': function (newVal, oldVal) {
            if (!XEUtils.isEqual(newVal, oldVal)) {
                this.getCourseInfo()
            }
        },
    },

    methods: {
        async getCourseInfo() {
            const vm = this
            vm.configs.loading = true
            await getCourseInfo({ ID: vm.LMIT_ID })
                .then(res => {
                    if (res.Code === 1 && res.Items.length > 0) {
                        vm.courseData = res.Items[0]
                        XEUtils.objectEach(vm.courseData, (value, key) => {
                            let columns = ['roles', 'rolesDetail']
                            if (columns.includes(key)) {
                                vm.courseData[key] = JSON.parse(value)
                            }
                        })

                        let bookingTime = `<br /><br />可預約時間：<br />${vm.courseData.LMIT_BSTime} 到 ${vm.courseData.LMIT_BETime}`
                        if (XEUtils.getDateDiff(new Date(), new Date(vm.courseData.LMIT_BSTime)).done) {
                            vm.bookingMsg = `課程尚未開放預約!!${bookingTime}`
                            vm.chkCourse = false
                        } else if (XEUtils.getDateDiff(new Date(vm.courseData.LMIT_BETime), new Date()).done) {
                            vm.bookingMsg = `課程預約時間已經結束!!${bookingTime}`
                            vm.chkCourse = false
                        } else if (vm.courseData.balance <= 0) {
                            vm.bookingMsg = '已額滿!'
                            vm.chkCourse = false
                        } else {
                            vm.bookingMsg = ''
                            vm.chkCourse = true
                            // console.log('可以預約')
                        }

                        vm.$store.dispatch('app/cachePNTitle', vm.courseData.LMIT_Name_1000) // 將title寫入快取給breadcrumb讀取
                    }
                })
                .then(() => {
                    vm.$store.dispatch('user/checkLogin').then(isLogin => {
                        if (isLogin) {
                            vm.$store.dispatch('user/getUserInfo').then(() => {
                                vm.user = vm.$store.getters.userInfo
                                // vm.getFeedbackList() /* 舊版程式填寫評論功能已關閉 */
                                if (vm.chkCourse) vm.checkBooking()
                            })
                        }
                        vm.configs.loading = false
                    })
                })
        },

        async getFeedbackList() {
            const vm = this
            vm.configs.loading = true
            let params = {
                Acpd_ID: vm.user.id,
                LMIT_ID: vm.LMIT_ID,
            }
            await getFeedbackList(params)
                .then(res => {
                    if (res.Code === 1 && res.Items.length > 0) {
                        vm.canComment = true
                        vm.submitted = !!res.Items[0].Feedback || !!res.Items[0].Score
                        vm.score = !res.Items[0].Score ? 3 : res.Items[0].Score
                        vm.feedback = !res.Items[0].Feedback ? '' : res.Items[0].Feedback
                        // vm.$message({
                        //     message: res.Msg,
                        //     type: 'success',
                        // })
                    } else {
                        vm.canComment = false
                    }
                })
                .then(() => {
                    vm.configs.loading = false
                })
        },

        async updateBookingFeedback() {
            const vm = this
            const fullscreenLoading = vm.$loading({
                lock: true,
                text: '請稍候，目前正處理評價與回饋...',
                background: 'rgba(255, 255, 255, 0.5)',
            })
            let params = {
                Acpd_ID: vm.user.id,
                LMIT_ID: vm.LMIT_ID,
                Score: vm.score,
                Feedback: vm.feedback,
            }
            await updateBookingFeedback(params).then(res => {
                if (res.Code === 1) {
                    vm.$message({
                        type: 'success',
                        message: res.Msg,
                    })
                    vm.$confirm('是否要返回我的課程清單?', '提示', {
                        confirmButtonText: '確定',
                        cancelButtonText: '取消',
                        type: 'info',
                        dangerouslyUseHTMLString: true,
                    })
                        .then(() => {
                            vm.$router.push('/mycourse')
                        })
                        .catch(() => {
                            vm.getFeedbackList()
                        })
                }
                fullscreenLoading.close()
            })
        },

        submitFeeback() {
            this.$confirm('確定要儲存評價與回饋訊息?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'info',
                dangerouslyUseHTMLString: true,
            }).then(() => {
                this.updateBookingFeedback()
            })
        },

        async checkBooking() {
            const vm = this
            let params = {
                Acpd_ID: vm.user.id,
                Acpd_Class: vm.user.class,
                LMIT_ID: vm.courseData.LMIT_ID,
                ExcludedMember: vm.courseData.excludedMember,
                ExcludedDetail: vm.courseData.excludedDetail,
            }
            await checkBooking(params).then(res => {
                vm.bookingMsg = res.Msg
                vm.chkRole = res.Items.HasPassed
                vm.user.sdrgValue = res.Items.SdrgValue
                vm.user.sdrgText = res.Items.SdrgText
                vm.user.statusText = res.Items.StatusText
                vm.user.absent = res.Items.Absent
            })
        },

        async bookCourse() {
            const vm = this
            const fullscreenLoading = vm.$loading({
                lock: true,
                text: '請稍候，目前正處理課程預約...',
                background: 'rgba(255, 255, 255, 0.5)',
            })
            let params = {
                Acpd_ID: vm.user.id,
                LMIT_ID: vm.courseData.LMIT_ID,
                Acpd_Class: vm.user.class,
                Name: vm.user.name,
                Email: vm.user.email,
                Phone: vm.user.phone,
                SdrgValue: vm.user.sdrgValue,
                SdrgText: vm.user.sdrgText,
            }
            await bookCourse(params)
                .then(res => {
                    if (res.Code === 1) {
                        vm.$message({ type: 'success', message: res.Msg, dangerouslyUseHTMLString: true })
                    }
                })
                .then(() => {
                    fullscreenLoading.close()
                })
        },

        submitRegister() {
            const vm = this
            vm.$refs['form'].validate(valid => {
                if (valid) {
                    vm.bookCourse().then(() => {
                        vm.$store.dispatch('app/reloadComponents', !vm.$store.getters.reload)
                    })
                }
            })
        },

        go2CourseLs() {
            window.history.go(-1)
        },
    },
}
</script>

<style scoped lang="scss">
:deep .el-pagination {
    button {
        width: auto;
    }
}
.bottom {
    margin-top: 15px;
    padding-top: 10px;
    border-top: 1px solid #ccc;

    button {
        width: auto;
        height: auto;
    }
}
:deep .class_content_text {
    .el-form-item__label {
        font-size: 18px;
        color: #808080;
    }

    .el-form-item__content {
        .el-input input {
            color: #212529;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            border-radius: 25px;
            border-color: #2d9698;
            height: 35px;
        }
        .el-input input:focus {
            background-color: #fff;
            border-color: #86b7fe;
            box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }
    }
}
:deep .el-select .el-input .el-input__inner {
    font-size: 1rem;
    color: #2d9698;
    border-color: #2d9698;
}
:deep .el-select .el-input.is-focus .el-input__inner {
    font-size: 1rem;
    color: #2d9698;
    border-color: #2d9698;
}
:deep .submit-booking {
    width: 180px;
    height: 38px;
    font-size: 20px;
    padding: 5px 50px;
    border-radius: 25px;
    background-color: #2d9698;
    color: #fff;
}
:deep .submit-booking:hover {
    width: 180px;
    height: 38px;
    font-size: 20px;
    padding: 5px 50px;
    border-radius: 25px;
    background-color: #37b4b6;
    color: #fff;
}
:deep .go-back {
    width: 180px;
    height: 38px;
    font-size: 20px;
    padding: 5px 50px;
    border-radius: 25px;
    background-color: #cccccc;
    color: #fff;
}
:deep .go-back:hover {
    width: 180px;
    height: 38px;
    font-size: 20px;
    padding: 5px 50px;
    border-radius: 25px;
    background-color: #ccccccbb;
    color: #fff;
}
:deep .submit-feedback {
    width: 180px;
    height: 38px;
    font-size: 20px;
    padding: 5px 50px;
    border-radius: 25px;
    background-color: #635095;
    color: #fff;
}
:deep .submit-feedback:hover {
    width: 180px;
    height: 38px;
    font-size: 20px;
    padding: 5px 50px;
    border-radius: 25px;
    background-color: #7765a4;
    color: #fff;
}
</style>

<style lang="scss">
.el-message-box {
    button {
        width: auto;
        height: auto;
    }
}
</style>
